import { list } from "./list";

export const LocationsEndpoint = {
  list,
};
